import { render, staticRenderFns } from "./multipleChoice7.vue?vue&type=template&id=234faf3c&scoped=true"
import script from "./multipleChoice7.vue?vue&type=script&lang=js"
export * from "./multipleChoice7.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice7.vue?vue&type=style&index=0&id=234faf3c&prod&lang=css"
import style1 from "./multipleChoice7.vue?vue&type=style&index=1&id=234faf3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234faf3c",
  null
  
)

export default component.exports